import { SubMenuList } from '../../SubMenu'

import * as styles from './IdwellToIdwellSubMenuFiltersSection.module.css'

function IdwellToIdwellSubMenuFiltersSection({
  className = styles.IdwellToIdwellSubMenuFiltersSection,
  ...restProps
}) {
  return (
    <div className={className}>
      <SubMenuList {...restProps} />
    </div>
  )
}

export default IdwellToIdwellSubMenuFiltersSection
